module.exports = __webpack_public_path__ + "static/coinbase_logo-3075e5f06fd33a6da218aad481c35545.png";